export const DOMAIN =
    process.env.REACT_APP_API_DOMAIN || "http://localhost:8080";